export default "__VITE_ASSET__f1f7ad3d__"